module.exports = __webpack_public_path__ + "static/media/warning_blue.db4affb0.svg";